export default __webpack_public_path__ + "static/dinosors-3fc9602e3ef91a517701889dd1108701.jpeg";